
import Vue from 'vue';

// Types
import {
    CandidateProfileScore,
    CandidateProfileScorer,
} from '~/utils/candidate/CandidateProfileScorer';
import { User } from '~/services/types/identity';
import { Candidate } from '~/services/types/candidate';
import { WorkAuthorization } from '~/services/types/candidate';

// Components
import Progress from '~/components/builders/Progress.vue';
import URLS from '~/URLS';

export default Vue.extend({
    name: 'AccountDetails',
    components: { Progress },
    props: {},
    computed: {
        profile: {
            get(): User {
                return this.$store.getters['profileModule/getUser']();
            },
            set(value: User) {
                this.$store.commit('profileModule/setUser', value);
            },
        },
        candidate: {
            get(): Candidate {
                return this.$store.getters['profileModule/getCandidate']();
            },
            set(value: Candidate) {
                this.$store.commit('profileModule/setCandidate', value);
            },
        },
        workAuthorizations: {
            get(): WorkAuthorization[] {
                return this.$store.getters['profileModule/getWorkAuthorizations']();
            },
            set(value: WorkAuthorization[]) {
                this.$store.commit('profileModule/setWorkAuthorizations', value);
            },
        },
        score(): CandidateProfileScore | null {
            if (this.candidate && this.profile && this.workAuthorizations) {
                return new CandidateProfileScorer(
                    this.candidate,
                    this.profile,
                    this.workAuthorizations
                ).getProfileScore();
            }
            return null;
        },
        user(): User | undefined {
            return this.profile || {};
        },
        fullName(): string {
            if (!this.user) return '';
            return (this.user.firstName || '') + ' ' + (this.user.lastName || '');
        },
        nameAbbr(): string {
            if (!this.user) return '';
            return this.user.firstName ? this.user.firstName[0] : '';
        },
        email(): string {
            if (!this.user) return '';
            return this.user.email || '';
        },
        profilePicture(): string {
            if (!this.user) return '';
            return this.user.avatar || '';
        },
    },
    methods: {
        goToProfile() {
            this.$router.push({ path: URLS.profile });
        },
    },
});
